import * as http from './base-api'
import * as querystring  from 'querystring'



/**
 * 좋아요 목록 검색
 *
 * @param params
 * @returns {*}
 */

export const retrieveLikes= (params) => {
   return http.get(`/cms/likes?${querystring.stringify(params)}`)

}
